import styled from '@emotion/styled';
import BaseButton from '@material-ui/core/Button';
import theme from '../../../themes/default';

export const Container = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  padding-top: 12px;
  padding-bottom: 24px;
  padding-left: 35px;
  padding-right: 28px;
`;

export const DateContainer = styled('div')`
  display: flex;
  flex-direction: column;
`;

export const TimeOuterContainer = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
`;

export const TimeContainer = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: ${theme.spacing.xxSmall};
`;

export const MeridiemContainer = styled('div')`
  display: flex;
  flex-direction: column;
`;

const HeaderButton = styled(BaseButton, {
  shouldForwardProp: (prop) => prop !== 'selected',
})`
  position: relative;
  text-transform: none;
  padding: 0;
  min-width: 0px;
  color: ${({ selected }) =>
    selected ? theme.color.purple3 : theme.color.designSystem.blackOpacity60};
`;

export const SmallButton = styled(HeaderButton)`
  width: fit-content;
  font-weight: normal;
  font-size: ${theme.font.size.copy};
  line-height: 20px;
`;

export const LargeButton = styled(HeaderButton)`
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
`;

export const SeparatorText = styled('span')`
  font-size: 24px;
  font-weight: 500;
  line-height: 28px;
  color: ${theme.color.designSystem.blackOpacity60};
`;
